export const DEFAULT_PAGE_RELOAD_DELAY_MS = 2500;

type SchedulePageReloadOptions = {
  delayMs?: number;
  reload?: () => void;
};

let scheduledPageReload: number | undefined;

export function schedulePageReload({ delayMs = DEFAULT_PAGE_RELOAD_DELAY_MS, reload }: SchedulePageReloadOptions = {}) {
  if (typeof window === "undefined" || scheduledPageReload !== undefined) {
    return;
  }

  scheduledPageReload = window.setTimeout(() => {
    scheduledPageReload = undefined;
    if (reload) {
      reload();
    } else {
      window.location.reload();
    }
  }, delayMs);
}

export function clearScheduledPageReload() {
  if (typeof window !== "undefined" && scheduledPageReload !== undefined) {
    window.clearTimeout(scheduledPageReload);
  }

  scheduledPageReload = undefined;
}
